import { render } from "./App.vue?vue&type=template&id=04bb9f04"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=04bb9f04&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/messages-app V2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__